<template>
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.0764 7C13.0764 8.71822 11.6835 10.1111 9.96532 10.1111C8.2471 10.1111 6.85421 8.71822 6.85421 7C6.85421 5.28178 8.2471 3.88889 9.96532 3.88889C11.6835 3.88889 13.0764 5.28178 13.0764 7ZM11.5209 7C11.5209 7.85911 10.8244 8.55556 9.96532 8.55556C9.10621 8.55556 8.40976 7.85911 8.40976 7C8.40976 6.14089 9.10621 5.44444 9.96532 5.44444C10.8244 5.44444 11.5209 6.14089 11.5209 7Z"
      fill="#F7B643"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.96532 0C14.3143 0 17.9685 2.97447 19.0046 7C17.9685 11.0255 14.3143 14 9.96532 14C5.61636 14 1.96213 11.0255 0.926025 7C1.96213 2.97447 5.61636 0 9.96532 0ZM9.96532 12.4444C6.48432 12.4444 3.53412 10.1563 2.54316 7C3.53412 3.84367 6.48432 1.55556 9.96532 1.55556C13.4463 1.55556 16.3965 3.84367 17.3875 7C16.3965 10.1563 13.4463 12.4444 9.96532 12.4444Z"
      fill="#F7B643"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
